import React, { useEffect, useState } from 'react';
import { useFetch } from 'use-http';
import Dialog from 'src/components/common/Dialog.redesign';
import Form from 'src/components/controls/forms/Form';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import { AnyObject } from 'final-form';
import { Url } from 'src/api';
import { useSelector } from 'react-redux';
import { IRootState } from 'src/reducers';
import { EasternTownshipTypeArray } from 'src/models/EasternTownshipType';
import { SelectItem } from 'src/models/common/SelectItem';
import EasternTownship from 'src/models/EasternTownship';
import County from 'src/models/County';
import Button from 'src/components/controls/forms/redesign/FormButton';
import TagContainer from 'src/components/counties/TagContainer';
import _ from 'lodash';
import { FormErrors } from 'src/util/FormErrors';

interface IEasterMapDialogProps {
    onCloseDialog?: () => void;
    onUpdateComplete: (townshipId: number) => void;
    action: 'create' | 'edit' | 'delete';
    townshipId: number;
}

const EasternTownshipDialog: React.FC<IEasterMapDialogProps> = (props) => {
    const [easternTownship, setEasternTownship] = useState<EasternTownship>(undefined);
    const [counties, setCounties] = useState<County[]>([]);
    const [form, setForm] = useState(undefined);
    const { get, put, post, response } = useFetch();
    const appContext = useSelector((state: IRootState) => state.appContext);

    const loadData = async () => {
        let townshipResult: EasternTownship = undefined;
        if (props.townshipId) {
            townshipResult = await get(Url.project.getEasternTownship(appContext, props.townshipId));
        }

        const countiesResult = await get(Url.project.getProjectCounties(appContext));

        if (response.ok) {
            setEasternTownship(townshipResult);
            setCounties(countiesResult.items);
        }
    };

    useEffect(() => {
        loadData();
    }, [props.townshipId]);

    const onValidate = (values: AnyObject) => {
        const errors: AnyObject = {};

        if (!values.townshipTypeId) {
            errors.townshipTypeId = 'Township Type is required';
        }

        return errors as FormErrors;
    };

    const onSubmit = async (values: AnyObject) => {
        const township = new EasternTownship();
        township.easternTownshipTypeId = values.townshipTypeId;
        township.name = values.name;
        township.number = values.number;
        if (props.townshipId) {
            township.id = props.townshipId;
            township.counties = _.unionBy(easternTownship.counties, values.addCounties, 'id');
            township.counties = _.differenceBy(township.counties, values.deleteCounties, 'id');
        } else {
            township.counties = values.addCounties;
        }

        if (props.action === 'create') {
            const result = await post(Url.project.getEasternTownships(appContext), township);
            if (response.ok) {
                if (props.onUpdateComplete) {
                    props.onUpdateComplete(result.id);
                }
                props.onCloseDialog();
            }
        }

        if (props.action === 'edit') {
            await put(Url.project.getEasternTownship(appContext, props.townshipId), township);
            if (response.ok) {
                if (props.onUpdateComplete) {
                    props.onUpdateComplete(props.townshipId);
                }
                props.onCloseDialog();
            }
        }
    };

    const createInitialValues = () => {
        if (easternTownship) {
            return {
                name: easternTownship.name,
                counties: easternTownship.counties,
                number: easternTownship.number,
                townshipTypeId: easternTownship.easternTownshipTypeId,
            };
        }

        return undefined;
    };

    const actionText = `${props.townshipId ? 'Update' : 'Create'} Township`;

    return (
        <Dialog title={actionText}>
            <Form
                onSubmit={onSubmit}
                validate={onValidate}
                initialValues={createInitialValues()}
                onFormCreated={!form && setForm}
                hasFieldArray={true}
            >
                <FormSelect
                    label="Township Type"
                    items={EasternTownshipTypeArray().map((i) => new SelectItem(i.id, i.name))}
                    name="townshipTypeId"
                    isRequired={true}
                />
                <FormTextBox label="Name" name="name" />
                <FormTextBox label="Number" name="number" />
                {/* <FormSelect label="County" name="countyId" items={counties?.map(c => new SelectItem(c.id, c.name))} /> */}
                <TagContainer
                    label="Counties"
                    fieldArrayName="counties"
                    fieldAddArrayName="addCounties"
                    fieldDeleteArrayName="deleteCounties"
                    initialValueName="county"
                    isTagCreatable={false}
                    form={form}
                    selectTags={counties ? counties.map((c) => new SelectItem(c.id, c.name)) : new Array<SelectItem>()}
                />
                <Button type="submit" text={actionText} />
            </Form>
        </Dialog>
    );
};

export default EasternTownshipDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/dialogs/EasternTownshipDialog.tsx